// extracted by mini-css-extract-plugin
export default {"delivery-communication-consent":"DeliveryCommunicationConsent-module__delivery-communication-consent___34Bxx"};